const INVITE_PARAM = 'invite';
const INVITE_STORAGE_KEY = 'courses:inviteToken';

function readStored(): string | null {
	try {
		return window.sessionStorage.getItem(INVITE_STORAGE_KEY);
	} catch {
		return null;
	}
}

export function extractInviteToken(target: string | null | undefined): string | null {
	if (!target) return null;
	try {
		return new URL(target, 'http://local').searchParams.get(INVITE_PARAM)?.trim() || null;
	} catch {
		return null;
	}
}

export function rememberInviteToken(token: string | null | undefined): void {
	if (!token) return;
	try {
		window.sessionStorage.setItem(INVITE_STORAGE_KEY, token);
	} catch {
		return;
	}
}

export function clearInviteToken(): void {
	try {
		window.sessionStorage.removeItem(INVITE_STORAGE_KEY);
	} catch {
		return;
	}
}

export function resolveInviteToken(redirect?: string | null): string | null {
	return extractInviteToken(redirect) ?? readStored();
}

export function inviteTokenPayload(redirect?: string | null): { inviteToken?: string } {
	const inviteToken = resolveInviteToken(redirect);

	return inviteToken ? { inviteToken } : {};
}
